/* Centralized i18n strings */
export const S = {
  brand: { hi: "एचआर डिजिटल सर्विसेज", en: "HR Digital Services" },
  tagline: { hi: "सरकारी नौकरी अपडेट्स · सोलर सेवाएँ · कागदाना, सिरसा", en: "Govt Job Updates & Solar Services · Kagdana, Sirsa" },
  nav: {
    home: { hi: "होम", en: "Home" },
    about: { hi: "हमारे बारे में", en: "About" },
    services: { hi: "सेवाएँ", en: "Services" },
    enquiry: { hi: "सोलर पूछताछ", en: "Solar Enquiry" },
    solar: { hi: "सोलर", en: "Solar" },
    loan: { hi: "लोन", en: "Loan" },
    csc: { hi: "CSC सेवाएँ", en: "CSC Services" },
    irrigation: { hi: "सिंचाई / कृषि", en: "Irrigation / Farm" },
    vacancies: { hi: "भर्तियाँ", en: "Vacancies" },
    solar_services: { hi: "सोलर सेवाएँ", en: "Solar Services" },
    blogs: { hi: "ब्लॉग", en: "Blogs" },
    gallery: { hi: "गैलरी", en: "Gallery" },
    notices: { hi: "सूचना बोर्ड", en: "Notices" },
    downloads: { hi: "डाउनलोड", en: "Downloads" },
    faq: { hi: "प्रश्न", en: "FAQ" },
    contact: { hi: "संपर्क", en: "Contact" },
    dashboard: { hi: "डैशबोर्ड", en: "Dashboard" },
    login: { hi: "लॉगिन", en: "Login" },
    register: { hi: "रजिस्टर", en: "Register" },
    logout: { hi: "लॉगआउट", en: "Logout" },
  },
  hero: {
    slide1_title: { hi: "PM सूर्य घर मुफ्त बिजली योजना", en: "PM Surya Ghar Free Electricity Scheme" },
    slide1_sub: { hi: "₹78,000 तक की सब्सिडी और 300 यूनिट मुफ्त बिजली प्रति माह पाएँ", en: "Get up to ₹78,000 subsidy and 300 units of free electricity per month" },
    slide2_title: { hi: "रूफटॉप सोलर पर 40% तक सब्सिडी", en: "Up to 40% Subsidy on Rooftop Solar" },
    slide2_sub: { hi: "आज ही आवेदन करें और अपनी बिजली की लागत कम करें", en: "Apply today and reduce your electricity cost" },
    slide3_title: { hi: "सोलर एवं व्यावसायिक लोन 5.75% ब्याज दर पर", en: "Solar & Business Loans at 5.75% Interest" },
    slide3_sub: { hi: "आसान EMI · तेज़ मंज़ूरी · न्यूनतम दस्तावेज़", en: "Easy EMI · Fast approval · Minimal documents" },
    apply_now: { hi: "अभी आवेदन करें", en: "Apply Now" },
    know_more: { hi: "और जानें", en: "Know More" },
  },
  services: {
    title: { hi: "हमारी मुख्य सेवाएँ", en: "Our Core Services" },
    sub: { hi: "सरकारी योजनाओं और वित्तीय सुविधाओं का सम्पूर्ण समाधान", en: "One-stop solution for government schemes & financial services" },
    surya: { hi: "PM सूर्य घर पंजीकरण", en: "PM Surya Ghar Registration" },
    surya_desc: { hi: "मुफ्त बिजली योजना के लिए तुरंत रजिस्ट्रेशन करें।", en: "Register instantly for the free electricity scheme." },
    rooftop: { hi: "रूफटॉप सोलर लीड", en: "Rooftop Solar Lead" },
    rooftop_desc: { hi: "अपनी छत पर सोलर पैनल के लिए एक्सपर्ट सर्वे।", en: "Expert survey for rooftop solar panels." },
    subsidy: { hi: "सब्सिडी जानकारी", en: "Subsidy Information" },
    subsidy_desc: { hi: "केंद्र और राज्य सरकार की सभी सब्सिडी की पूरी जानकारी।", en: "Complete info on all central & state subsidies." },
    install: { hi: "इंस्टॉलेशन रिक्वेस्ट", en: "Installation Request" },
    install_desc: { hi: "प्रमाणित इंस्टॉलर्स द्वारा जल्दी इंस्टॉलेशन।", en: "Fast installation by certified installers." },
    loan_app: { hi: "लोन आवेदन", en: "Loan Application" },
    loan_app_desc: { hi: "सोलर, बिज़नेस और पर्सनल लोन आसान EMI पर।", en: "Solar, business and personal loans on easy EMI." },
    status: { hi: "स्टेटस ट्रैकिंग", en: "Status Tracking" },
    status_desc: { hi: "अपने आवेदन की स्थिति ऑनलाइन देखें।", en: "Track your application status online." },
    docs: { hi: "दस्तावेज़ अपलोड", en: "Document Upload" },
    docs_desc: { hi: "सुरक्षित तरीके से दस्तावेज़ अपलोड करें।", en: "Securely upload your documents online." },
    contact_us: { hi: "संपर्क करें", en: "Contact Us" },
    contact_desc: { hi: "किसी भी सहायता के लिए हमें कॉल या व्हाट्सएप करें।", en: "Call or WhatsApp us for any assistance." },
  },
  common: {
    apply: { hi: "आवेदन करें", en: "Apply" },
    submit: { hi: "जमा करें", en: "Submit" },
    cancel: { hi: "रद्द करें", en: "Cancel" },
    save: { hi: "सेव करें", en: "Save" },
    email: { hi: "ईमेल", en: "Email" },
    password: { hi: "पासवर्ड", en: "Password" },
    name: { hi: "पूरा नाम", en: "Full Name" },
    phone: { hi: "मोबाइल नंबर", en: "Mobile Number" },
    read_more: { hi: "और पढ़ें", en: "Read More" },
    latest_updates: { hi: "ताज़ा सूचनाएँ", en: "Latest Updates" },
    important: { hi: "महत्वपूर्ण", en: "Important" },
    downloadForms: { hi: "फॉर्म डाउनलोड करें", en: "Download Forms" },
    testimonials: { hi: "ग्राहकों की राय", en: "Customer Testimonials" },
  },
};
